import type { SleepActivityState } from "./SleepActivityContext";
import { paths } from "@src/packages/openapi/schema";
import { RequestBody } from "@src/packages/openapi/helpers";

type PatchPayload = RequestBody<
  paths["/{tenantId}/patients/{patientId}"]["patch"]
>;

export function transformSleepActivityStateToRequest(
  state: SleepActivityState,
): PatchPayload {
  const lifestyle: any = {};

  if (state.lifestyleId) lifestyle.id = state.lifestyleId;

  if (state.minHoursOfSleep !== null)
    lifestyle.minHoursOfSleep = state.minHoursOfSleep;
  if (state.maxHoursOfSleep !== null)
    lifestyle.maxHoursOfSleep = state.maxHoursOfSleep;

  if (state.isExercising !== null) lifestyle.isExercising = state.isExercising;

  if (state.isExercising === true) {
    if (state.minHoursOfExercise !== null)
      lifestyle.minHoursOfExercise = state.minHoursOfExercise;
    if (state.maxHoursOfExercise !== null)
      lifestyle.maxHoursOfExercise = state.maxHoursOfExercise;
  } else if (state.isExercising === false) {
    lifestyle.minHoursOfExercise = null;
    lifestyle.maxHoursOfExercise = null;
  }

  if (Object.keys(lifestyle).length === 0) return {};
  return { lifestyle };
}
